import MarkDownRenderer from '../../../../../commonComponents/MarkDownRender/MarkDownRender.Component';

export const markdownContent = `
## **Message Tab**

The **Message** tab is where you send gRPC request payloads.

### ✍️ Writing Messages
- Messages are written in **JSON format**
- Fields map directly to the protobuf message schema
- Auto-formatting is supported

### 🔁 Streaming Controls
For streaming RPCs:
- **Send** → sends one message
- **End Stream** → closes client stream
- Multiple messages can be sent sequentially

### 📂 Load Example Message
Click **Load Ex. Message** to auto-populate a valid request based on the proto definition.

Example:
\`\`\`json
{
  "greeting": "shyam"
}
\`\`\`
`;

const GRPCMessageTab = () => {
    return (
        <MarkDownRenderer
            title="Message"
            markDownText={markdownContent}
        />
    );
};

export default GRPCMessageTab;
